import { NotificationBanner } from '@sevenrooms/ui-kit/layout'
import { ColumnTimeSlots } from './ColumnTimeSlots/ColumnTimeSlots'
import { RowPreviewTimeSlots } from './RowPreviewTimeSlots'
import { RowTimeSlots } from './RowTimeSlots/RowTimeSlots'
import type { ReservationTimeSlotVariant } from '../../../../components/ReservationTimeslot'
import type { AvailabilityTimeWithUpSellCost } from '../../../../hooks'
import type { ReactNode } from 'react'

export interface TimeSlotsProps {
  direction?: 'row' | 'column' | 'row_preview'
  descriptionType?: 'short' | 'full'
  timeSlots?: AvailabilityTimeWithUpSellCost[]
  requestOrPriorityAlertAvailability?: ReactNode
  noAvailabilityMessage?: ReactNode
  currencyCode: string
  startDate?: string
  timeSlotVariant?: ReservationTimeSlotVariant
  timeSlotsDisplayCount?: number
  onTimeSlotClick?: (slot: AvailabilityTimeWithUpSellCost) => void
  onDateClick?: () => void
  onShowMoreClick?: () => void
}

export function TimeSlots({
  direction = 'column',
  timeSlots,
  requestOrPriorityAlertAvailability,
  noAvailabilityMessage,
  onTimeSlotClick,
  startDate,
  timeSlotVariant = 'primary',
  timeSlotsDisplayCount,
  currencyCode,
  descriptionType,
  onDateClick,
  onShowMoreClick,
}: TimeSlotsProps) {
  if (timeSlots?.length) {
    if (direction === 'column') {
      return (
        <ColumnTimeSlots
          timeslots={timeSlots}
          descriptionType={descriptionType}
          onTimeSlotClick={onTimeSlotClick}
          timeSlotVariant={timeSlotVariant}
          timeSlotsDisplayCount={timeSlotsDisplayCount}
          startDate={startDate}
          onDateLabelClick={onDateClick}
          currencyCode={currencyCode}
          requestOrPriorityAlertAvailability={requestOrPriorityAlertAvailability}
        />
      )
    }
    if (direction === 'row') {
      return (
        <RowTimeSlots
          timeslots={timeSlots}
          descriptionType={descriptionType}
          onTimeSlotClick={onTimeSlotClick}
          timeSlotVariant={timeSlotVariant}
          startDate={startDate}
          onDateLabelClick={onDateClick}
          currencyCode={currencyCode}
          requestOrPriorityAlertAvailability={requestOrPriorityAlertAvailability}
        />
      )
    }
    return (
      <RowPreviewTimeSlots
        timeslots={timeSlots}
        descriptionType={descriptionType}
        onTimeSlotClick={onTimeSlotClick}
        timeSlotVariant={timeSlotVariant}
        currencyCode={currencyCode}
        onShowMoreClick={onShowMoreClick}
        requestOrPriorityAlertAvailability={requestOrPriorityAlertAvailability}
      />
    )
  }

  if (noAvailabilityMessage) {
    return <NotificationBanner type="info" data-test="sr-room-card-no-availability-text" showIcon content={noAvailabilityMessage} />
  }

  return null
}
